import { Serie } from "@nivo/line";

export const CHART_COLORS = [
  "#2563eb",
  "#dc2626",
  "#16a34a",
  "#ea580c",
  "#7c3aed",
  "#059669",
  "#d97706",
  "#0ea5e9",
  "#c026d3",
  "#0891b2",
];

export type LegendDatum = {
  id: string | number;
  label: string;
  color: string;
};

export type LegendConfig = {
  anchor: "bottom";
  direction: "row";
  translateY: number;
  itemWidth: number;
  itemHeight: number;
  itemsSpacing: number;
  symbolSize: number;
  symbolShape: "circle";
  data: LegendDatum[];
};

export const resolveSeriesColors = (series: Serie[]): string[] =>
  series.map((entry, index) => {
    const color = (entry as Serie & { color?: string }).color;
    return color ?? CHART_COLORS[index % CHART_COLORS.length];
  });

export const buildLegendConfigs = (
  series: Serie[],
  colors: string[],
  chunkSize = 3
): LegendConfig[] => {
  const configs: LegendConfig[] = [];
  const total = series.length;

  for (let start = 0; start < total; start += chunkSize) {
    const chunk = series.slice(start, start + chunkSize);
    const data: LegendDatum[] = chunk.map((entry, idx) => {
      const color =
        colors[start + idx] ??
        CHART_COLORS[(start + idx) % CHART_COLORS.length];
      const id = entry.id ?? `Series ${start + idx + 1}`;
      return {
        id,
        label: typeof entry.id === "string" ? entry.id : String(id),
        color,
      };
    });

    configs.push({
      anchor: "bottom",
      direction: "row",
      translateY: 80 + configs.length * 26,
      itemWidth: 100,
      itemHeight: 20,
      itemsSpacing: 100,
      symbolSize: 1,
      symbolShape: "circle",
      data,
    });
  }

  return configs;
};

export const getChartBottomMargin = (legendCount: number) =>
  legendCount > 0 ? 80 : 60;

export const getUniqueYearsFromSeries = (series: Serie[]): number[] => {
  const values = new Set<number>();
  series.forEach((entry) => {
    entry.data.forEach((point) => {
      const asNumber =
        typeof point.x === "number" ? point.x : Number(point.x);
      if (!Number.isNaN(asNumber)) {
        values.add(asNumber);
      }
    });
  });
  return Array.from(values).sort((a, b) => a - b);
};
